export enum TabsMenuOptionsRoutes {
  Dashboard = "dashboard",
  Dados = "dados",
  Pessoas = "pessoas",
  Veiculos = "veiculos",
  Pets = "pets",
  Documentos = "Documentos",
  ParametrizacaoDeCobranca = "parametrização de cobrança",
  HistoricoCobranca = 'histórico de cobrança'
}

export const TabMenuOptions: {
  label: string;
  route: TabsMenuOptionsRoutes;
  permissions: string[];
}[] = [
    {
      label: "Dashboard",
      route: TabsMenuOptionsRoutes.Dashboard,
      permissions: [],
    },
    {
      label: "Dados Cadastrais",
      route: TabsMenuOptionsRoutes.Dados,
      permissions: [],
    },
    {
      label: "Pessoas",
      route: TabsMenuOptionsRoutes.Pessoas,
      permissions: [],
    },
    {
      label: "Veículos",
      route: TabsMenuOptionsRoutes.Veiculos,
      permissions: [],
    },
    {
      label: "Pets",
      route: TabsMenuOptionsRoutes.Pets,
      permissions: [],
    },
    {
      label: "Documentos",
      route: TabsMenuOptionsRoutes.Documentos,
      permissions: [],
    },
    {
      label: "Parametrização de Cobrança",
      route: TabsMenuOptionsRoutes.ParametrizacaoDeCobranca,
      permissions: [],
    },
    {
      label: "Histórico de Cobrança",
      route: TabsMenuOptionsRoutes.HistoricoCobranca,
      permissions: [],
    },
  ];
